export default function HapticIcon({ size = 20, ...props }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false"
            {...props}
        >
            <rect x="8" y="4" width="8" height="16" rx="2" />
            <path d="M4 9v6" />
            <path d="M20 9v6" />
            <path d="M1.5 10.5v3" />
            <path d="M22.5 10.5v3" />
        </svg>
    );
}
